import React from 'react';

// Components
import SearchProduct from '../../components/searchProducts';

const Catalogs = () => {
    return (
        <SearchProduct />
    )
}

export default Catalogs;